export class Period {
    periodFrom: Date;
    periodTom: Date;
}
